import DEFAULTS from '../../../utils/defaultValues';

export const stateReducer = (prev, action) => {
  switch (action.type) {
    case 'SET_BY_PATH': {
      const { path, value } = action;
      const readAtPath = (obj, p) => p.split('.').reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
      const segments = path.split('.');
      const newState = { ...prev };
      let cursor = newState;
      for (let i = 0; i < segments.length - 1; i++) {
        const key = segments[i];
        cursor[key] = Array.isArray(cursor[key]) ? [...cursor[key]] : { ...(cursor[key] || {}) };
        cursor = cursor[key];
      }
      const current = readAtPath(prev, path);
      const resolved = typeof value === 'function' ? value(current) : value;
      cursor[segments[segments.length - 1]] = resolved;
      return newState;
    }
    case 'SET_MANY': {
      return { ...prev, ...action.payload };
    }
    default:
      return prev;
  }
};

export const initialState = DEFAULTS;

export const createAlias = (state, setByPath) => (getterPath, setterPath = getterPath) => ({
  get value() {
    const segments = getterPath.split('.');
    let cur = state;
    for (const s of segments) cur = cur[s];
    return cur;
  },
  set: (valueOrUpdater) => setByPath(setterPath, valueOrUpdater)
});

export const createAliases = (state, setByPath) => {
  const alias = createAlias(state, setByPath);
  
  return {
    // UI
    ui: {
      isRotatedArrow: alias('ui.isRotatedArrow'),
      isRotatedBox: alias('ui.isRotatedBox'),
      isReversed: alias('ui.isReversed'),
      orientation: alias('ui.orientation'),
      isAddingNew: alias('ui.isAddingNew'),
      items: alias('ui.items'),
    },
    // Modals
    modals: {
      customModalOpen: alias('modals.customModalOpen'),
      showQuoteDetailsModal: alias('modals.showQuoteDetailsModal'),
      showLengthLimitModal: alias('modals.showLengthLimitModal'),
      showSpacerModal: alias('modals.showSpacerModal'),
      lengthLimitMessage: alias('modals.lengthLimitMessage'),
    },
    // Lists
    lists: {
      customers: alias('lists.customers'),
      saws: alias('lists.saws'),
      conveyorStyles: alias('lists.conveyorStyles'),
      dropdownOptions: alias('lists.dropdownOptions'),
    },
    // Selections
    selections: {
      selectedSaw: alias('selections.selectedSaw'),
      selectedCustomer: alias('selections.selectedCustomer'),
      selectedCustomerName: alias('selections.selectedCustomerName'),
      selectedRollerLength: alias('selections.selectedRollerLength'),
      leftBoxRollerLength: alias('selections.leftBoxRollerLength'),
      rightBoxRollerLength: alias('selections.rightBoxRollerLength'),
      selectedConveyorStyle: alias('selections.selectedConveyorStyle'),
      leftBoxConveyorStyle: alias('selections.leftBoxConveyorStyle'),
      rightBoxConveyorStyle: alias('selections.rightBoxConveyorStyle'),
      additionalEmails: alias('selections.additionalEmails'),
      selectedAdditionalEmails: alias('selections.selectedAdditionalEmails'),
      selectedContact: alias('selections.selectedContact'),
    },
    // Boxes
    boxes: {
      leftBoxItems: alias('boxes.leftBoxItems'),
      rightBoxItems: alias('boxes.rightBoxItems'),
      activeBox: alias('boxes.activeBox'),
      checkedItems: alias('boxes.checkedItems'),
      flippedBoxes: alias('boxes.flippedBoxes'),
      filenameFlipStates: alias('boxes.filenameFlipStates'),
      motorSelections: alias('boxes.motorSelections'),
      taSelections: alias('boxes.taSelections'),
      stkSelections: alias('boxes.stkSelections'),
      leftBoxCacheClear: alias('boxes.leftBoxCacheClear'),
      rightBoxCacheClear: alias('boxes.rightBoxCacheClear'),
    },
    // Cache
    cache: {
      globalImageCache: alias('cache.globalImageCache'),
    },
    // Lengths & Buttons
    lengthsAndButtons: {
      infeedLength: alias('lengthsAndButtons.infeedLength'),
      outfeedLength: alias('lengthsAndButtons.outfeedLength'),
      buttonsEnabled: alias('lengthsAndButtons.buttonsEnabled'),
    },
    // Form
    form: {
      formFields: alias('form.formFields'),
    },
    // Quote
    quote: {
      isQuoteCreated: alias('quote.isQuoteCreated'),
      quoteNumber: alias('quote.quoteNumber'),
      quoteDetails: alias('quote.quoteDetails'),
      brochure: alias('quote.brochure'),
    },
    // Data
    data: {
      sampleData: alias('data.sampleData'),
    },
    // Images/details
    images: {
      motorVariantImageUrls: alias('images.motorVariantImageUrls'),
      taImageUrls: alias('images.taImageUrls'),
      stkImageUrls: alias('images.stkImageUrls'),
      motorVariantDetails: alias('images.motorVariantDetails'),
      taDetails: alias('images.taDetails'),
      stkDetails: alias('images.stkDetails'),
    },
    // Motors
    motors: {
      motorVariantByBox: alias('motors.motorVariantByBox'),
      motorDetailsByBox: alias('motors.motorDetailsByBox'),
      isFlipped: alias('motors.isFlipped'),
      usedRefreshOnce: alias('motors.usedRefreshOnce'),
    },
    // STK
    stk: {
      stkVariantByPortion: alias('stk.stkVariantByPortion'),
    },
    // TA
    ta: {
      taVariantByPortion: alias('ta.taVariantByPortion'),
    },
    // Media
    media: {
      sawImage: alias('media.sawImage'),
    },
  };
};
